import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/sharp-solid-svg-icons';
import { useCallback, useState } from 'react';
import { SCView } from '../view';
import './index.css';

interface SCButtonProps {
  title?: string;
  label?: string;
  icon?: IconProp;
  onClick?: () => any;
  htmlType?: 'submit';
  disabled?: boolean;
  DataTestId?: string;
}

function SCButton(props: SCButtonProps) {
  const { title, label, icon, onClick, disabled, htmlType = 'button', DataTestId } = props;
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async () => {
    if (disabled || loading) return;
    setLoading(true);
    try {
      await onClick?.();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [disabled, loading, onClick]);

  return (
    <button
      type={htmlType}
      className="sc-button"
      onClick={handleClick}
      disabled={disabled || loading}
      title={title}
      data-testid={DataTestId}
    >
      <SCView flex gap={2} itemsCenter>
        {(icon || loading) && (
          <FontAwesomeIcon icon={loading ? faSpinnerThird : icon!} spin={loading} />
        )}
        {label}
      </SCView>
    </button>
  );
}

export { SCButton };
export type { SCButtonProps };
